import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "grid grid-cols-12 gap-5 p-5" }
const _hoisted_2 = { class: "col-span-12 sm:col-span-3 lg:col-span-3 xl:col-span-3" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "col-span-12 sm:col-span-9 lg:col-span-9 xl:col-span-9 flex items-center p-2" }
const _hoisted_5 = { class: "flex flex-col gap-3 text-center md:text-start w-full" }
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = { class: "flex flex-row justify-between w-full items-center hidden md:flex" }
const _hoisted_8 = { class: "flex flex-col items-center justify-center w-full md:hidden text-center" }
const _hoisted_9 = { class: "mt-2" }
const _hoisted_10 = { class: "mt-2" }
const _hoisted_11 = {
  key: 0,
  class: "w-full flex flex-col gap-3"
}
const _hoisted_12 = {
  key: 1,
  class: "w-full flex flex-col gap-3"
}
const _hoisted_13 = { class: "mt-8" }
const _hoisted_14 = { class: "mt-2 p-4 bg-white border-b-2 border-h-primary-500 space-y-4 rounded-md shadow-md" }
const _hoisted_15 = { class: "flex flex-wrap justify-start items-center gap-5" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("strong", null, "60%", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageVoice = _resolveComponent("MessageVoice")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", {
      class: _normalizeClass(`rounded-md bg-contain md:bg-cover md:bg-center shadow-md md:shadow-sm ${_ctx.color()}`),
      style: _normalizeStyle(_ctx.backgroundImage(_ctx.background()))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.avatar(),
            alt: "homero-state",
            class: "w-full h-56"
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.title()), 1),
                _createVNode(_component_MessageVoice, {
                  msg: _ctx.message()
                }, null, 8, ["msg"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.title()), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_MessageVoice, {
                    msg: _ctx.message()
                  }, null, 8, ["msg"])
                ])
              ]),
              _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.message()), 1)
            ]),
            (_ctx.data?.percentage >= 60)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_Button, {
                    class: "btn-primary h-10",
                    loading: _ctx.loading,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onProceed('proceed')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("quiz.result.proceed")), 1)
                    ]),
                    _: 1
                  }, 8, ["loading"]),
                  (_ctx.isAdaptative)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        class: "btn-outline-bg-white h-10",
                        loading: _ctx.loading,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onProceed('more-materials')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("quiz.result.more")), 1)
                        ]),
                        _: 1
                      }, 8, ["loading"]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Vamos começar?",
                  en: "Let's start?",
                })), 1),
                  _createVNode(_component_Button, {
                    class: "btn-primary h-12 md:h-10",
                    loading: _ctx.loading,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onProceed('quiz-materials')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("quiz.result.moreMaterialsQuiz")), 1)
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]))
          ])
        ])
      ])
    ], 6),
    _createElementVNode("h4", _hoisted_13, _toDisplayString(_ctx.$t("labels.generic", { pt: "Correção do Quiz", en: "Quiz correction" })), 1),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", null, [
        _createElementVNode("p", null, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("quiz.result.currentPercentage").concat(": ")) + ": ", 1),
          _createElementVNode("strong", null, _toDisplayString(_ctx.data?.percentage) + "%", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("p", null, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("quiz.result.minPercentage").concat(": ")), 1),
          _hoisted_16
        ]),
        _createElementVNode("p", null, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("quiz.result.duration").concat(": ")), 1),
          _createElementVNode("strong", null, _toDisplayString(_ctx.generics.getDurationTime(_ctx.data?.elapsedTime)), 1)
        ])
      ])
    ])
  ], 64))
}